import createFinance from '@/store/modules/finance/finance-create'
import editFinance from '@/store/modules/finance/finance-edit'
import getFinance from '@/store/modules/finance/finance-get'

export default {
  createFinance,
  editFinance,
  getFinance,
}
